<template>
    <div class="fileUp">
        <label :class="[{ SelectedCursor: isActive }, 'ui-upload']">
            <span :class="[{ Selected: isActive }, 'el-icon-upload', 'tubiao']"></span>
            <span :class="[{ Selected: isActive }, 'textUp']">{{proName}}</span>
            <input @change="Upload" :disabled="isActive" ref="selector"
                   type="file" class="file" style="display: none">
        </label>
    </div>
</template>

<script>
    export default {
        name: "uploadModal",
        data() {
            return {
                proName: "点击选择上传文件",
                isActive: false,
            }
        },
        props: {
            fileData: {
                type: Object,
                required: true
            }
        },
        mounted() {
        },
        methods: {
            newData() {
                this.proName = "点击选择上传文件",
               this.isActive = false;
            },
            Upload2() {
                $('.file')[0].value = '';
                $('.file')[0].type = 'text'
                setTimeout(() => {
                    $('.file')[0].type = 'file'
                }, 200)
            },
            Upload(e) {
                var files = this.$refs.selector.files;
                if (files.length > 0) {
                    this.proName = "点击选择上传文件",
                        this.isActive = false;
                }
                this.$emit("fileUpload", files );
            },
            getData(name,v){
                this.proName = name
                this.isActive = v;
            }
        }
    }
</script>
<style lang="less" scoped>
    .fileUp {
        padding-bottom: 20px;
    }
    .ui-upload {
        height: 90px;
        width: 120px;
        font-size: 15px;
        line-height: 30px;
        cursor: pointer;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        text-align: center;
        border-radius: 5px;
        justify-content: center;
        border: 1px dashed #409EFF;
        padding: 0 10px;
        span:nth-of-type(2) {
            width: 100%;
        }
        .tubiao {
            color: rgba(64, 158, 255, 0.46);
            font-size: 70px;
            line-height: 60px;
            height: 60px;
        }
        .textUp {
            color: #409EFF;
        }
        .Selected {
            color: rgba(199, 199, 199, 0.67);
        }
    }
    .SelectedCursor {
        cursor: default;
        border: 1px dashed rgba(199, 199, 199, 0.67);
    }


</style>
